// extracted by mini-css-extract-plugin
export default {"section":"TwdFr","header":"pKIsU","headerText":"w_L3s","inner":"Wwb17"};